<template>
  <div class="container container_com-fundo container_com-margem" id="consulta-por-cpf">
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <div class="formulario">
        <h2 class="titulo titulo_grande u-margem-esquerda-pequena">
          Informe o CPF do pretendente para solicitar o subsídio para o projeto
          {{ projeto.Nome }}
        </h2>
        <p
          role="tooltip"
          id="mensagem-atencao"
          class="formulario__mensagem formulario__mensagem_atencao u-margem-esquerda-pequena u-margem-inferior-pequena"
        >
          <i class="far fa-exclamation-triangle formulario__mensagem-icone"></i>
          <span class="u-esconder-acessivel">Atenção: </span>
          É necessário que o solicitante esteja cadastrado no
          <a
            :href="urlInscricaoCompartilhada"
            title="Clique para se inscrever"
            target="_blank"
            ><span class="u-margem-esquerda-mini">
              sistema de inscrição da AGEHAB</span
            ></a
          >
        </p>
        <div class="grade__linha grade__linha_alinhar-vertical-a-base">
          <div class="formulario">
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_2">
                <input
                  id="cpf"
                  type="text"
                  placeholder="Insira somente números do CPF"
                  v-model="cpf"
                  v-mask="'999.999.999-99'"
                />
              </div>
              <div class="grade__coluna grade__coluna_4">
                <button
                  v-if="true"
                  type="button"
                  @click="obterProtocoloPorCpf"
                  class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                  Adicionar
                </button>
              </div>
            </div>
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_5">
                <h5 class="titulo titulo_cor-terciaria" v-for="proponente in proponentes">
                  {{ proponente.Nome }}
                  {{ proponente.Conjuge ? `, ${proponente.Conjuge.Nome}` : "" }}
                  <button
                    v-if="true"
                    type="button"
                    @click="removerProponente(proponente)"
                    class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </h5>
              </div>
            </div>
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_4">
                <button
                  type="button"
                  class="botao botao_medio botao_cinza"
                  @click="retornarParaSelecaoDeProjetos"
                >
                  Cancelar
                </button>
                <button
                  :disabled="!possuiProponentes"
                  type="submit"
                  @click="avancar"
                  class="botao botao_medio botao_cor-terciaria u-margem-superior-media"
                  :class="{ 'is-loading': loading }"
                >
                  {{
                    projeto.DeveComprovarRendaFamiliar ? "Avançar" : "Solicitar subsídio"
                  }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="container container_com-fundo container_com-margem"
      v-if="deveExibirFormularioParaRendaFamiliarComprovada"
    >
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <div class="formulario">
        <h2
          class="titulo titulo_grande u-margem-inferior-media u-margem-esquerda-pequena"
        >
          Informe a renda apurada pelo agente financeiro
        </h2>
        <div class="grade__linha grade__linha_alinhar-vertical-a-base">
          <div class="grade__coluna grade__coluna_4">
            <label class="formulario__label" for="renda-familiar-comprovada"
              >Renda Familiar</label
            >
            <input
              name="renda-familiar-comprovada"
              type="text"
              id="renda-familiar-comprovada"
              class="formulario__input"
              placeholder="Insira a renda familiar"
              v-model="dadosParaValidacaoDaRendaFamiliarComprovada.RendaFamiliar"
              v-mask="'money'"
              required
            />
            <button
              type="button"
              class="botao botao_medio botao_cinza"
              @click="retornarParaSelecaoDeProjetos"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="botao botao_medio botao_cor-terciaria u-margem-superior-media"
              :class="{ 'is-loading': loading }"
              @click="validarRendaFamiliarComprovada"
            >
              Solicitar subsídio
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Loading from "../shared/Loading";
import Alerta from "../shared/Alerta";

export default {
  name: "consulta-por-cpf",
  components: { Loading, Alerta },

  data() {
    return {
      proponentes: [],
      cpf: null,
      loading: false,
      linkDoInscricao: false,
      textoDoAlerta: null,
      tipoDoAlerta: null,
      urlInscricaoCompartilhada: process.env.URL_INSCRICAO_COMPARTILHADA,
      projetos: this.projetos || [],
      projeto: {},
      dadosParaValidacaoDaRendaFamiliarComprovada: {},
      tipoDeAlerta: null,
      mensagemDeAlerta: null,
      deveExibirFormularioParaRendaFamiliarComprovada: false,
      loading: {
        visivel: false,
      },
    };
  },
  created() {
    const projeto = localStorage.getItem("projeto");
    this.projeto = JSON.parse(projeto);
  },
  directives: { mask: AwesomeMask },
  computed: {
    possuiProponentes() {
      return this.proponentes.length > 0;
    },
  },
  methods: {
    obterProtocoloPorCpf() {
      this.ocultarAlerta();
      const proponenteJaFoiAdicionado = this.proponentes.some((p) => p.Cpf === this.cpf);
      if (!this.cpf || proponenteJaFoiAdicionado) {
        this.cpf = null;
        return;
      }
      this.exibirCarregamento();
      let dadosParaConsultaDoSolicitanteDto = {
        Cpf: this.cpf,
        ProjetoId: this.projeto.Id,
      };
      this.$api
        .post("/solicitante", dadosParaConsultaDoSolicitanteDto)
        .then((resultado) => {
          this.esconderCarregamento();
          if (resultado.data === null) {
            let mensagem =
              "Cadastro do solicitante não encontrado. Por favor, oriente cadastrar-se no Inscrição Compartilhada.";
            this.exibirAlerta(mensagem, "atencao");
          } else {
            if (!proponenteJaFoiAdicionado) {
              const protocolo = resultado.data;
              this.adicionarProponente(protocolo);
              this.cpf = null;
            }
          }
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    adicionarProponente(protocolo) {
      const cidadesDoProponente = this.agruparPorCidade();
      var todosOsProponentesSaoDaMesmaCidade =
        this.proponentes.length == 0 ||
        (parseInt(cidadesDoProponente[0]) == protocolo.IdCidade &&
          cidadesDoProponente.length == 1);

      if (todosOsProponentesSaoDaMesmaCidade) {
        const titular = protocolo.Titular;
        const proponente = {
          Nome: titular.Nome,
          Cpf: this.formatarCPF(titular.Cpf),
          Renda: titular.ValorDaRenda,
          Telefone: titular.Telefone,
          DataDeNascimento: titular.DataDeNascimento,
          Cidade: protocolo.Cidade,
          CidadeId: protocolo.IdCidade,
          EhMulherVitimaDeViolenciaDomestica:
            titular.EhMulherVitimaDeViolenciaDomestica,
          EhMulherChefeDeFamilia: titular.MulherChefeDeFamilia,
          EhIdoso: titular.EhIdoso,
          EhPessoaComDeficiencia: titular.EhPessoaComDeficiencia,
          EhIndigena: titular.EhIndigena,
          EhQuilombola: titular.FamiliaQuilombola,
          EhNegroOuPardo: titular.EhNegroOuPardo,
          PossuiOnusExcessivoComAluguel: titular.PossuiOnusExcessivoComAluguel,
          PossuiFamiliaEmCoabitacao: titular.PossuiFamiliaEmCoabitacao,
          Conjuge: null,
        };

        if (protocolo.Conjuge) {
          const conjuge = {
            Nome: protocolo.Conjuge.Nome,
            Cpf: this.formatarCPF(protocolo.Conjuge.Cpf),
            Renda: protocolo.Conjuge.ValorDaRenda,
            Telefone: protocolo.Conjuge.Telefone,
            DataDeNascimento: protocolo.Conjuge.DataDeNascimento,
            Cidade: protocolo.Cidade,
            CidadeId: protocolo.IdCidade,
            EhMulherVitimaDeViolenciaDomestica:
              protocolo.Conjuge.EhMulherVitimaDeViolenciaDomestica,
            EhMulherChefeDeFamilia: protocolo.Conjuge.MulherChefeDeFamilia,
            EhIdoso: protocolo.Conjuge.EhIdoso,
            EhPessoaComDeficiencia: protocolo.Conjuge.EhPessoaComDeficiencia,
            EhIndigena: protocolo.Conjuge.EhIndigena,
            EhQuilombola: protocolo.Conjuge.FamiliaQuilombola,
            EhNegroOuPardo: protocolo.Conjuge.EhNegroOuPardo,
            PossuiOnusExcessivoComAluguel:
              protocolo.Conjuge.PossuiOnusExcessivoComAluguel,
            PossuiFamiliaEmCoabitacao:
              protocolo.Conjuge.PossuiFamiliaEmCoabitacao,
          };
          proponente.Conjuge = conjuge;
        }

        this.proponentes.push(proponente);
        this.$localStorage.atribuir("proponentes", this.proponentes);
      } else {
        this.exibirAlerta("Todos os proponentes devem ser da mesma cidade");
      }
    },
    removerProponente(proponente) {
      var index = this.proponentes.indexOf[proponente];
      this.proponentes.splice(index, 1);
    },
    avancar() {
      if (this.projeto.DeveComprovarRendaFamiliar)
        this.exibirFormularioParaComprovacaoDaRendaFamiliar();
      else this.redirecionarParaFormularioDeSolicitacao();
    },
    validarRendaFamiliarComprovada() {
      let dto = JSON.parse(
        JSON.stringify(this.$data.dadosParaValidacaoDaRendaFamiliarComprovada)
      );
      let valorInvalido =
        Object.keys(dto).length === 0 ||
        this.$moeda.removerFormatacao(dto.RendaFamiliar) === 0;

      if (valorInvalido) {
        this.exibirAlerta(
          "Verifique o campo preenchido e insira o valor da renda familiar corretamente"
        );
        return;
      }

      dto.RendaFamiliar = this.$moeda.removerFormatacao(dto.RendaFamiliar);
      dto.ProjetoId = this.projeto.Id;

      this.exibirCarregamento();
      this.$api
        .post("/solicitante/ValidarRendaFamiliarComprovada", dto)
        .then(() => {
          this.esconderCarregamento();
          this.$localStorage.atribuir("rendaFamiliarComprovada", dto.RendaFamiliar);
          this.redirecionarParaFormularioDeSolicitacao(dto.ProjetoId);
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    redirecionarParaFormularioDeSolicitacao(projetoId) {
      this.$router.push({
        name: "FormularioDeSolicitacao",
        params: { projetoId: projetoId },
      });
    },
    exibirFormularioParaComprovacaoDaRendaFamiliar() {
      this.deveExibirFormularioParaRendaFamiliarComprovada = true;
    },
    tratarErro(error) {
      this.esconderCarregamento();
      let mensagensDeErro = error.response.data.Message;
      this.exibirAlerta(mensagensDeErro);
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    ocultarAlerta() {
      this.textoDoAlerta = null;
      this.mensagemDeAlerta = null;
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    retornarParaSelecaoDeProjetos() {
      this.deveExibirFormularioParaRendaFamiliarComprovada = false;
      this.mensagemDeAlerta = null;
      this.cpf = null;
      this.limparProjetoSelecionado();
      this.definirProjetoPadrao();
    },
    definirProjetoPadrao() {
      let projetoPadrao = this.criarProjetoPadrao();
      this.projeto = projetoPadrao;
    },
    criarProjetoPadrao() {
      return {
        Id: null,
        Nome: "Selecione o projeto",
        DeveComprovarRendaFamiliar: false,
      };
    },
    limparProjetoSelecionado() {
      this.projeto = {};
    },
    exibirAlerta(mensagem) {
      this.tipoDeAlerta = "erro";
      this.mensagemDeAlerta =
        mensagem || "Ocorreu um erro interno. Tente novamente ou contate o suporte";
    },
    agruparPorCidade() {
      const itensAgrupados = this.proponentes.reduce(
        (groups, item) => ({
          ...groups,
          [item.CidadeId]: [...(groups[item.CidadeId] || []), item],
        }),
        {}
      );
      return Object.keys(itensAgrupados);
    },
    formatarCPF(cpf) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConsultaPorCpf.vue?913673e6